import React, { useState, useEffect } from "react";
import ModalComponent from "../../../ModalComponent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import { useTranslation } from "react-i18next";
import * as HTTPServices from "../../../../api/HTTPServices";
import _ from "lodash";
import { useUserState } from "../../../../providers/UserProvider";
import sampleUser from "../../../../assets/images/sampleUser/118-118.png";
import UserTextMessage from "../..//RoomBody/TextMessage/userTextMessage";
import AudienceTextMessage from "../../RoomBody/TextMessage/audienceTextMessage";
import UserPictureMessage from "../../RoomBody/PictureMessage/userPictureMessage";
import AudiencePictureMessage from "../../RoomBody/PictureMessage/audiencePictureMessage";
import UserVideoMessage from "../../RoomBody/VideoMessage/userVideoMessage";
import AudienceVideoMessage from "../../RoomBody/VideoMessage/audienceVideoMessage";
import UserVoiceMessage from "../../RoomBody/VoiceMessage/userVoiceMessage";
import AudienceVoiceMessage from "../../RoomBody/VoiceMessage/audienceVoiceMessage";

import classes from "./index.module.scss";

const Index = ({
  handleOpenDocuments,
  handleCloseDocuments,
  audienceId,
  visitToken,
  SeenAttach,
}) => {
  const user = useUserState();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [dossierText, setDossierText] = useState([]);
  const [dossierVideoMessage, setDossierVideoMessage] = useState([]);
  const [dossierVoice, setDossierVoice] = useState([]);
  const [dossierFile, setDossierFile] = useState([]);
  const [dossierPhoto, setDossierPhoto] = useState([]);
  const userType = user?.user_login?.approve;

  useEffect(() => {
    const fetchFIle = () => {
      const RequestService = HTTPServices.getMethod(
        "chat",
        "audience=" + audienceId + "&token=" + visitToken,
        "true"
      );

      RequestService.then(function (response) {
        if (response) {
          let res = response;
          let dossierPhoto = [];
          let dossierFile = [];
          let dossierVoice = [];
          let dossierVideoMessage = [];
          let dossierText = [];

          _.map(res, (item) => {
            if (item.type === "dossierPhoto") {
              dossierPhoto.push(item);
            } else if (item.type === "dossierFile") {
              dossierFile.push(item);
            } else if (item.type === "dossierVoice") {
              dossierVoice.push(item);
            } else if (item.type === "dossierVideoMessage") {
              dossierVideoMessage.push(item);
            } else if (item.type === "dossierText") {
              dossierText.push(item);
            }
          });
          setDossierText(dossierText);
          setDossierVideoMessage(dossierVideoMessage);
          setDossierVoice(dossierVoice);
          setDossierFile(dossierFile);
          setDossierPhoto(dossierPhoto);

          SeenAttach(audienceId, visitToken);
        }
      }).catch(function (error) {});
    };
    fetchFIle();
  }, [SeenAttach, audienceId, visitToken]);

  const renderDossierText = () => {
    return dossierText.map((item) =>
      item.user_id === user?.user_login?.client_id ? (
        <UserTextMessage message={item.message} imgSrc={sampleUser} />
      ) : (
        <AudienceTextMessage message={item.message} imgSrc={sampleUser} />
      )
    );
  };

  const renderDossierPhoto = () => {
    return dossierPhoto.map((item) =>
      item.user_id === user?.user_login?.client_id ? (
        <UserPictureMessage chat={item} imgSrc={sampleUser} />
      ) : (
        <AudiencePictureMessage chat={item} imgSrc={sampleUser} />
      )
    );
  };

  const renderDossierFile = () => {
    return dossierFile.map((item) =>
      item.user_id === user?.user_login?.client_id ? (
        <UserPictureMessage chat={item} imgSrc={sampleUser} />
      ) : (
        <AudiencePictureMessage chat={item} imgSrc={sampleUser} />
      )
    );
  };

  const renderVideoMessage = () => {
    return dossierVideoMessage.map((item) =>
      item.user_id === user?.user_login?.client_id ? (
        <UserVideoMessage chat={item} src={item.file} imgSrc={sampleUser} />
      ) : (
        <AudienceVideoMessage chat={item} src={item.file} imgSrc={sampleUser} />
      )
    );
  };

  const renderDossierVoice = () => {
    return dossierVideoMessage.map((item) =>
      item.user_id === user?.user_login?.client_id ? (
        <UserVoiceMessage chat={item} src={item.file} imgSrc={sampleUser} />
      ) : (
        <AudienceVoiceMessage chat={item} src={item.file} imgSrc={sampleUser} />
      )
    );
  };

  const NoRecordToView = () => (
    <div>
      <figure>
        {/* <img src={DossierIcon} alt="nothing Found" /> */}
        <figcaption>
          <p>
            {t(
              "components.AppointmentRoom.RoomHeader.DocumentsModal.noRecordsToView"
            )}
          </p>
          <p>{t("components.AppointmentRoom.RoomHeader.DocumentsModal.add")}</p>
        </figcaption>
      </figure>
    </div>
  );

  function a11yProps(index) {
    return {
      id: `scrollable-prevent-tab-${index}`,
      "aria-controls": `scrollable-prevent-tabpanel-${index}`,
    };
  }
  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  return (
    <ModalComponent
      open={handleOpenDocuments}
      handleClose={handleCloseDocuments}
      closeBtn={true}
      confirmBtn={false}
      handleOk={null}
      title={t("components.AppointmentRoom.RoomHeader.DocumentsModal.title")}
    >
      {userType && userType === "doctor" && (
        <div style={{ margin: 10, paddingRight: 15 }}>
          <p>
            {t(
              "components.AppointmentRoom.RoomHeader.DocumentsModal.patientName"
            )}
          </p>
          <p>
            {t(
              "components.AppointmentRoom.RoomHeader.DocumentsModal.patiantAge"
            )}
          </p>
        </div>
      )}

      <Tabs
        value={activeTab}
        // indicatorColor="yellow"
        textColor="primary"
        onChange={handleChangeTab}
        style={{
          borderTop: "1px solid",
          borderColor: "#e2dfdf",
        }}
        TabIndicatorProps={{ style: { background: "#f7b500" } }}
        variant="scrollable"
        scrollButtons="auto"
        fullWidth
        orientation="horizontal"
      >
        <Tab
          label={t(
            "components.AppointmentRoom.RoomHeader.DocumentsModal.basicExplanation"
          )}
          style={activeTab === 0 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(0)}
        />
        <Tab
          label={t(
            "components.AppointmentRoom.RoomHeader.DocumentsModal.pictures"
          )}
          style={activeTab === 1 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(1)}
        />
        <Tab
          label={t(
            "components.AppointmentRoom.RoomHeader.DocumentsModal.files"
          )}
          style={activeTab === 2 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(2)}
        />
        <Tab
          label={t(
            "components.AppointmentRoom.RoomHeader.DocumentsModal.videos"
          )}
          style={activeTab === 3 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(3)}
        />
        <Tab
          label={t(
            "components.AppointmentRoom.RoomHeader.DocumentsModal.audios"
          )}
          style={activeTab === 4 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(4)}
        />
      </Tabs>

      <TabPanel
        className={classes.scrolableContainer}
        value={activeTab}
        index={0}
      >
        <List>
          {dossierText && dossierText.length > 0 ? (
            renderDossierText()
          ) : (
            <NoRecordToView />
          )}
        </List>
      </TabPanel>
      <TabPanel
        className={classes.scrolableContainer}
        value={activeTab}
        index={1}
      >
        <List>
          {dossierPhoto && dossierPhoto.length > 0 ? (
            renderDossierPhoto()
          ) : (
            <NoRecordToView />
          )}
        </List>
      </TabPanel>
      <TabPanel
        className={classes.scrolableContainer}
        value={activeTab}
        index={2}
      >
        <List>
          {dossierFile && dossierFile.length > 0 ? (
            renderDossierFile()
          ) : (
            <NoRecordToView />
          )}
        </List>
      </TabPanel>
      <TabPanel
        className={classes.scrolableContainer}
        value={activeTab}
        index={3}
      >
        <List>
          {dossierVideoMessage && dossierVideoMessage.length > 0 ? (
            renderVideoMessage()
          ) : (
            <NoRecordToView />
          )}
        </List>
      </TabPanel>
      <TabPanel
        className={classes.scrolableContainer}
        value={activeTab}
        index={4}
      >
        <List>
          {dossierVoice && dossierVoice.length > 0 ? (
            renderDossierVoice()
          ) : (
            <NoRecordToView />
          )}
        </List>
      </TabPanel>
    </ModalComponent>
  );
};

export default Index;

const styles = {
  tab: {
    minWidth: 100,
    fontSize: 14,
  },
  activeTabStyle: {
    minWidth: 100,
    fontSize: 14,
    backgroundColor: "#fef8e6",
    color: "#f7b500",
  },
};
